import React, { useContext, useEffect } from 'react';
import GuidedFlow from '|/app/guided-flow';
import MobileDashboardContext from '|/app/mobile-dashboard-context';
import { Dashboard, Summary } from '|/app/services';
import NavigationRail from '|/app/steps/navigation-rail';

const defaultProps = {
  dashboard: null as null | Dashboard,
  summary: null as null | Summary
};

const DashboardRoute = ({ dashboard, summary } = defaultProps) => {
  const {
    showDashboardOnMobileRoute,
    setShowDashboardOnMobileRoute
  } = useContext(MobileDashboardContext);
  useEffect(() => {
    return () => setShowDashboardOnMobileRoute(false);
  }, [setShowDashboardOnMobileRoute]);
  return showDashboardOnMobileRoute ? (
    <>
      <NavigationRail dashboard={dashboard} summary={summary} />
    </>
  ) : (
    <GuidedFlow />
  );
};

export default DashboardRoute;
